import { createContext, useContext } from 'react'
import AppStore from './AppStore'
import SessionStore from './SessionStore'
import UserStore from './UserStore'
import OrganizationStore from './OrganizationStore'
import LogStore from './LogStore'
import AnalyticsStore from './AnalyticsStore'
import CouponStore from './CouponStore'
import NotificationStore from './NotificationStore'
import ItemStore from './ItemStore'
import PollStore from './PollStore'
import InfluenceStore from './InfluenceStore'

class RootStore {
  appStore
  sessionStore
  userStore
  organizationStore
  logStore
  analyticsStore
  entityStore
  couponStore
  notificationStore
  itemStore
  pollStore
  influenceStore

  constructor() {
    this.appStore = new AppStore(this)
    this.sessionStore = new SessionStore(this)
    this.userStore = new UserStore(this)
    this.organizationStore = new OrganizationStore(this)
    this.logStore = new LogStore(this)
    this.analyticsStore = new AnalyticsStore(this)
    this.couponStore = new CouponStore(this)
    this.notificationStore = new NotificationStore(this)
    this.itemStore = new ItemStore(this)
    this.pollStore = new PollStore(this)
    this.influenceStore = new InfluenceStore(this)
  }
}

export const createStore = () => {
  const rootStore = new RootStore()
  return rootStore
}

export const StoreContext = createContext({})
export const StoreProvider = StoreContext.Provider

export const useStore: any = () => useContext(StoreContext)
